// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .update {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}
.theme-light .update .wrapper {
  margin: auto;
  width: 40%;
  height: 70%;
  background-color: white;
  padding: 50px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.09);
  position: relative;
}
@media (max-width: 480px) {
  .theme-light .update .wrapper {
    width: 100%;
    height: 100%;
  }
}
.theme-light .update .wrapper h1 {
  color: lightgrey;
}
@media (max-width: 480px) {
  .theme-light .update .wrapper h1 {
    font-size: 20px;
  }
}
.theme-light .update .wrapper form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.theme-light .update .wrapper form .files {
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
}
.theme-light .update .wrapper form label {
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: gray;
  font-size: 14px;
}
.theme-light .update .wrapper form label .imgContainer {
  position: relative;
}
.theme-light .update .wrapper form label .imgContainer img {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.theme-light .update .wrapper form label .imgContainer .icon {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  font-size: 30px;
  color: lightgray;
  cursor: pointer;
}
.theme-light .update .wrapper form input {
  padding: 5px;
  border: none;
  border-bottom: 1px solid lightgray;
  color: gray;
  background-color: transparent;
}
.theme-light .update .wrapper form button {
  border: none;
  padding: 10px;
  cursor: pointer;
  color: white;
  background-color: #5271ff;
}
.theme-light .update .wrapper .close {
  position: absolute;
  top: 10px;
  right: 20px;
  border: none;
  background-color: #f0544f;
  padding: 5px;
  cursor: pointer;
  color: white;
}
.theme-dark .update {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}
.theme-dark .update .wrapper {
  margin: auto;
  width: 40%;
  height: 70%;
  background-color: #222;
  padding: 50px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.09);
  position: relative;
}
@media (max-width: 480px) {
  .theme-dark .update .wrapper {
    width: 100%;
    height: 100%;
  }
}
.theme-dark .update .wrapper h1 {
  color: lightgrey;
}
@media (max-width: 480px) {
  .theme-dark .update .wrapper h1 {
    font-size: 20px;
  }
}
.theme-dark .update .wrapper form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.theme-dark .update .wrapper form .files {
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
}
.theme-dark .update .wrapper form label {
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: gray;
  font-size: 14px;
}
.theme-dark .update .wrapper form label .imgContainer {
  position: relative;
}
.theme-dark .update .wrapper form label .imgContainer img {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.theme-dark .update .wrapper form label .imgContainer .icon {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  font-size: 30px;
  color: lightgray;
  cursor: pointer;
}
.theme-dark .update .wrapper form input {
  padding: 5px;
  border: none;
  border-bottom: 1px solid #444;
  color: gray;
  background-color: transparent;
}
.theme-dark .update .wrapper form button {
  border: none;
  padding: 10px;
  cursor: pointer;
  color: white;
  background-color: #5271ff;
}
.theme-dark .update .wrapper .close {
  position: absolute;
  top: 10px;
  right: 20px;
  border: none;
  background-color: #f0544f;
  padding: 5px;
  cursor: pointer;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/components/update/update.scss"],"names":[],"mappings":"AAqBI;ECjBA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAFJ;AAII;EACE,YAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EAGA,gDAAA;EACA,kBAAA;AAFN;ADiBE;EC5BE;IAgBI,WAAA;IACA,YAAA;EADN;AACF;AAGM;EACE,gBAAA;AADR;ADQE;ECRI;IAIG,eAAA;EAAP;AACF;AAIM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFR;AAIQ;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAFV;AAKQ;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AAHV;AAKU;EACE,kBAAA;AAHZ;AAIY;EACE,YAAA;EACA,aAAA;EACA,iBAAA;AAFd;AAKY;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAHd;AAQQ;EACE,YAAA;EACA,YAAA;EACA,kCAAA;EACA,WAAA;EACA,6BAAA;AANV;AASQ;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;AAPV;AAWM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AATR;AD/EI;ECjBA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAmGJ;AAjGI;EACE,YAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EAGA,gDAAA;EACA,kBAAA;AAmGN;ADpFE;EC5BE;IAgBI,WAAA;IACA,YAAA;EAoGN;AACF;AAlGM;EACE,gBAAA;AAoGR;AD7FE;ECRI;IAIG,eAAA;EAqGP;AACF;AAjGM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAmGR;AAjGQ;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAmGV;AAhGQ;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AAkGV;AAhGU;EACE,kBAAA;AAkGZ;AAjGY;EACE,YAAA;EACA,aAAA;EACA,iBAAA;AAmGd;AAhGY;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAkGd;AA7FQ;EACE,YAAA;EACA,YAAA;EACA,6BAAA;EACA,WAAA;EACA,6BAAA;AA+FV;AA5FQ;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;AA8FV;AA1FM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AA4FR","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.update {\n  @include themify($themes) {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 999;\n\n    .wrapper {\n      margin: auto;\n      width: 40%;\n      height: 70%;\n      background-color: themed(\"bg\");\n      padding: 50px;\n      z-index: 999;\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n      -webkit-box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.09);\n      -moz-box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.09);\n      box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.09);\n      position: relative;\n      \n      @include mobile {\n        width: 100%;\n        height: 100%;\n      }\n\n      h1 {\n        color: lightgrey;\n      \n        @include mobile {\n         font-size: 20px;\n        }\n      \n      }\n\n      form {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n\n        .files {\n          display: flex;\n          flex-wrap: wrap;\n          gap: 50px;\n        }\n\n        label {\n          display: flex;\n          flex-direction: column;\n          gap: 10px;\n          color: gray;\n          font-size: 14px;\n\n          .imgContainer {\n            position: relative;\n            img {\n              width: 100px;\n              height: 100px;\n              object-fit: cover;\n            }\n\n            .icon {\n              position: absolute;\n              top: 0;\n              bottom: 0;\n              left: 0;\n              right: 0;\n              margin: auto;\n              font-size: 30px;\n              color: lightgray;\n              cursor: pointer;\n            }\n          }\n        }\n\n        input {\n          padding: 5px;\n          border: none;\n          border-bottom: 1px solid themed(\"border\");\n          color: gray;\n          background-color: transparent;\n        }\n\n        button {\n          border: none;\n          padding: 10px;\n          cursor: pointer;\n          color: white;\n          background-color: #5271ff;\n        }\n      }\n\n      .close {\n        position: absolute;\n        top: 10px;\n        right: 20px;\n        border: none;\n        background-color: #f0544f;\n        padding: 5px;\n        cursor: pointer;\n        color: white;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
